import {
  AMAZON_AUTHOR_URL,
  FACEBOOK_URL,
  X_URL,
  YOUTUBE_URL,
  GOODREADS_URL,
} from "../lib/links";

const SocialMediaBar = () => {
  return (
    <ul className="social-media">
      <li>
        <a target="_blank" rel="noreferrer" href={AMAZON_AUTHOR_URL}>
          <i className="fab fa-amazon"></i>
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href={FACEBOOK_URL}>
          <i className="fab fa-facebook"></i>
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href={X_URL}>
          <i className="fab fa-x-twitter"></i>
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href={YOUTUBE_URL}>
          <i className="fab fa-youtube"></i>
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href={GOODREADS_URL}>
          <i className="fab fa-goodreads"></i>
        </a>
      </li>
    </ul>
  );
};

export default SocialMediaBar;
